import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import obelisco from "../Images/obelisco.JPG";
import ButtonArrow from "../components/ButtonArrow";
import CarouselComponent from "../components/CarouselComponent";
import sanEugenio from "../Images/sanEugenio.webp";
import hostelFamiliar from "../Images/hostelFamiliar.webp";
import tourMinero from "../Images/tourMinero.webp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMobileScreen } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "bootstrap";

const Artigas = () => {
  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    [...tooltipTriggerList].map((el) => new Tooltip(el));
  }, []);

  return (
    <main id="artigas" className="z-2 position-relative">
      <Helmet>
        <title>Artigas – Piedras preciosas, cultura, naturaleza y experiencias únicas.</title>
        <meta
          name="description"
          content="Descubrí Artigas: piedras preciosas, cultura viva, naturaleza y experiencias únicas. Alojamientos acogedores y actividades como el Safari Minero te esperan."
        />
        <meta
          name="keywords"
          content="Artigas Uruguay, piedras preciosas, amatistas, ágatas, cultura artiguense, naturaleza Uruguay, turismo Artigas, alojamientos Artigas, Hotel Casino San Eugenio, Hostel Familiar Artigas, Safari Minero, carnaval Bella Unión, experiencias únicas Uruguay"
        />

        <link rel="canonical" href="https://bellaunion.uy/artigas" />
        <meta property="og:title" content="Carnaval de Bella Unión – Tradición, Música y Fiesta" />
        <meta
          property="og:description"
          content="Descubrí Artigas: piedras preciosas, cultura viva, naturaleza y experiencias únicas. Alojamientos acogedores y actividades como el Safari Minero te esperan."
        />
        <meta property="og:url" content="https://bellaunion.uy/artigas" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={obelisco} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Carnaval de Bella Unión – Tradición, Música y Fiesta" />
        <meta
          name="twitter:description"
          content="Descubrí Artigas: piedras preciosas, cultura viva, naturaleza y experiencias únicas. Alojamientos acogedores y actividades como el Safari Minero te esperan."
        />
        <meta name="twitter:image" content={obelisco} />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <CarouselComponent image={obelisco} />
      <div
        className="position-absolute top-0 w-100 d-flex flex-column z-3 filter-dark"
        style={{ height: "100vh" }}
      >
        <h1 className="text-center text-light mt-auto">¡Explora Artigas!</h1>
        <div className="mb-auto text-center mt-5">
          <ButtonArrow />
        </div>
      </div>
      <div className="bg-light py-5" id="main-container" style={{ marginTop: "100vh" }}>
        <div className="container">
          <h5 className="text-center fw-light">
            Si visitás Bella Unión, también estás a las puertas de descubrir el departamento de Artigas:
            piedras preciosas, cultura, naturaleza y experiencias únicas.
          </h5>
          <h2 className="text-center mt-5">Alojamientos</h2>
          <div className="row g-3 mt-3 justify-content-center">
            <div className="col-lg-4 col-md-6">
              <div className="border rounded bg-white shadow">
                <div
                  className="rounded-top"
                  style={{
                    aspectRatio: "1 / 1",
                    backgroundImage: `url(${sanEugenio})`,
                    backgroundOrigin: "border-box",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                />
                <div className="p-3 bg-white rounded-bottom">
                  <h3 className="text-center">Hotel Casino San Eugenio del Cuareim</h3>
                  <p className="text-center">
                    Ubicado en el corazón de Artigas, en el cruce de la Av. Cnel. Carlos Lecueder y Luis A. de
                    Herrera, el Hotel Casino San Eugenio del Cuareim te recibe con la calidez de la
                    hospitalidad artiguense y un servicio excpcional en un hotel único.
                  </p>
                  <h5 className="text-center">Contacto</h5>
                  <div className="text-center">
                    <a
                      href={`tel:+59892249504`}
                      className="btn btn-transparent text-reset text-decoration-none"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Llamalos a su teléfono móvil"
                    >
                      <FontAwesomeIcon className="fs-2" style={{ color: "#4CAF50" }} icon={faMobileScreen} />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="border rounded bg-white shadow">
                <div
                  className="rounded-top"
                  style={{
                    aspectRatio: "1 / 1",
                    backgroundImage: `url(${hostelFamiliar})`,
                    backgroundOrigin: "border-box",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                />
                <div className="p-3 bg-white rounded-bottom">
                  <h3 className="text-center">Hostel Familiar Artigas</h3>
                  <p className="text-center">
                    Un hostel amplio, cómodo y lleno de luz — tu casa lejos de casa. Ambiente tranquilo,
                    seguro y lleno de paz, con atención familiar y la calidez que tu viaje merece.
                  </p>
                  <h5 className="text-center">Contacto</h5>
                  <div className="text-center">
                    <a
                      href={`tel:+59899392326`}
                      className="btn btn-transparent text-reset text-decoration-none"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Llamalos a su teléfono móvil"
                    >
                      <FontAwesomeIcon className="fs-2" style={{ color: "#4CAF50" }} icon={faMobileScreen} />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <h2 className="text-center mt-5">Actividades</h2>
          <div className="row g-3 mt-3 justify-content-center">
            <div className="col-lg-4 col-md-6">
              <div className="border rounded bg-white shadow">
                <div
                  className="rounded-top"
                  style={{
                    aspectRatio: "1 / 1",
                    backgroundImage: `url(${tourMinero})`,
                    backgroundOrigin: "border-box",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                />
                <div className="p-3 bg-white rounded-bottom">
                  <h3 className="text-center">Safari Minero</h3>
                  <p className="text-center">
                    Acompañados por un guía, viví una excursión única que te permite conocer el origen de las
                    ágatas y descubrir las amatistas de mayor pureza de la región.
                  </p>
                  <h5 className="text-center">Contacto</h5>
                  <div className="text-center">
                    <a
                      href={`tel:+59892249505`}
                      className="btn btn-transparent text-reset text-decoration-none"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Llamalos a su teléfono móvil"
                    >
                      <FontAwesomeIcon className="fs-2" style={{ color: "#4CAF50" }} icon={faMobileScreen} />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Artigas;
